/* eslint-disable import/prefer-default-export */
import PPImg from '../../../../assets/images/priority_processing.svg';
import FreeDelImg from '../../../../assets/images/free_delivery.svg';
import NMSCashImg from '../../../../assets/images/nms_cash.svg';

export const netmedsFirstData = [
  {
    name: '2.5% NMS Cash',
    subText: '(Max 100) on all prepaid orders',
    image: NMSCashImg,
  },
  {
    name: 'Free Delivery',
    subText: '',
    image: FreeDelImg,
  },
  {
    name: 'Priority Processing',
    subText: '',
    image: PPImg,
  },
  {
    name: 'Basic Health Checkup',
    subText: 'only with 12 month plan',
    image: NMSCashImg,
  },
  {
    name: 'Additional 5% off on Pathology Lab Tests',
    subText: '',
    image: FreeDelImg,
  },
  {
    name: 'Free Unlimited Consultation',
    subText: '',
    image: PPImg,
  },
];
